<template>
  <v-container class="d-flex justify-center">
    <v-col cols="12" md="9">
    <v-data-table
      :headers="clubHeaders"
      :items="clubs"
      item-key="id"
      class="elevation-1"
      :sort-by="['club_shortcut']"
      :sort-desc="[false]"
      :items-per-page="-1"
      :loading="loading"
      loading-text="general.loading"
      hover
    >
    <template v-slot:no-data>
        {{ $t('general.no_data') }}
    </template>
    <template #[`item.club_name`]="{ item }">
      <router-link :to="'/oddil/' + item.club_shortcut">{{ item.club_name }}</router-link>
    </template>
    <template #[`item.members`]="{ item }">
      {{ item.members }}
    </template>   
    <template #[`item.club_shortcut`]="{ item }">
      {{ item.club_shortcut }}
    </template>   
    <template v-slot:bottom></template> 
    </v-data-table>
    </v-col>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import apiClient from '/api.js';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const clubs = ref([]);
const clubHeaders = ref([
  { title: t('all_clubs.club_name'), align: 'start', key: 'club_name' },
  { title: t('all_clubs.members'), align: 'start', key: 'members', width: '100px' },
  { title: t('all_clubs.club_shortcut'), key: 'club_shortcut', width: '100px' },
]);

const loading = ref(true); 


// Načtení dat oddílů z API při vytvoření komponenty
onMounted(async () => {
  try {
    const response = await apiClient.get('club/');
    clubs.value = response.data.filter(club => club.club_type === 'CLUB');
  } catch (error) {
    console.error('Chyba při načítání oddílů:', error);
  } finally {
    loading.value = false;  // Nastavíme loading na false po načtení dat
  }
});
</script>

<style scoped>
</style>
